import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";
import { account } from "../lib/appwrite";
import { LoaderIcon } from "../components/svg/Icons";
import { addUser, getUserByDocument } from "../lib/actions";
import { useAuth } from "../context/AuthContext";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 75%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const FormContainer = styled.form`
  width: 100%;
  max-width: 400px;
  display: grid;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 48em) {
    width: 80%;
    margin: 1rem auto;
  }
`;

const InputBox = styled.input`
  padding: 0.8rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props) => props.theme.text};
  background-color: transparent;
  color: ${(props) => props.theme.text};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.primary};
  }
`;

const SubmitButton = styled.button`
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 2rem;
  border: none;
  cursor: pointer;
  background-color: ${(props) => props.theme.text};
  color: ${(props) => props.theme.body};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) => props.theme.primary};
  }
`;

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    if (!email || !password) {
      return toast.error("Please fill in all fields.");
    }

    setLoading(true);

    try {
      // Replace this with your login API call
      const userData = await handleLogin({ email, password });

      console.log(userData);
      login(userData);

      if (userData) {
        navigate("/dashboard");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
    }

    setLoading(false);
  };

  async function handleLogin({ email, password }) {
    try {
      // Clear existing session if any
      try {
        await account.get();
        await account.deleteSession("current");
      } catch (e) {
        // no session, ignore
      }

      // Login
      await account.createEmailPasswordSession(email, password);
      const user = await account.get();

      console.log(user)

      const exists = await getUserByDocument(user.$id);
      let new_user = null;

      if (!exists) {
        new_user = await addUser({
          userId: user.$id,
          email: user.email,
          name: user.name,
          username: user.email.split("@")[0],
        });
      }

      localStorage.setItem("userId", JSON.stringify(user.$id));

      toast.success("Login successful!");
      // ✅ Always return a valid user object
      return (
        new_user ??
        exists ?? {
          userId: user.$id,
          email: user.email,
          name: user.name,
        }
      );
    } catch (error) {
      console.error("Login failed:", error);
      toast.error("Login failed. Please check your credentials.");
      return null; // ✅ return null instead of undefined
    }
  }

  const renderButtonContent = () => {
    if (isLoading) {
      console.log("Loading...");
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "Login";
  };

  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <FormContainer onSubmit={handleSubmit}>
          <InputBox
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <InputBox
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <SubmitButton type="submit" disabled={isLoading}>
            {renderButtonContent()}
          </SubmitButton>

          <p style={{ textAlign: "center", marginTop: "1rem" }}>
            Don't have an account?{" "}
            <a href="/signup" style={{ color: "blue", cursor: "pointer" }}>
              Sign Up
            </a>
          </p>
        </FormContainer>
      </Container>
    </Section>
  );
};

export default Login;
